/** HTTP header values are Latin-1. Encode guest names so non-Latin-1 characters survive. */

export function encodeGuestNameHeader(name: string): string {
  return encodeURIComponent(name);
}

/**
 * Old clients send a raw Latin-1 name. A malformed escape (a literal `%`)
 * stays as the client sent it.
 */
export function decodeGuestNameHeader(raw: string | undefined): string | undefined {
  if (raw === undefined) return undefined;
  try {
    return decodeURIComponent(raw);
  } catch (err) {
    if (err instanceof URIError) return raw;
    throw err;
  }
}
